import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UnexpectedErrorStatusComponent } from './unexpected-error-status';

@NgModule({
  imports: [CommonModule],
  exports: [UnexpectedErrorStatusComponent],
  declarations: [UnexpectedErrorStatusComponent],
})
export class UnexpectedErrorStatusModule {}
